import { useFetch } from "~vue/api";
import type { SyncPerformanceReviewsResponse } from "~vue/types/performance_management";
import { ref } from "vue";

export const usePerformanceReviewSync = () => {
    const syncUrl = "/api/coach/performance_reviews/sync/";
    const payload = ref<{ performance_moment_id: number | null }>({
        performance_moment_id: null,
    });

    const { execute, ...fetch } = useFetch(syncUrl, { immediate: false }).post(payload).json<SyncPerformanceReviewsResponse>();

    // Failure reporting deliberately does not live here: the shared api layer logs the generic
    // event, and PerformanceMomentEndOfYear's mount handler owns the enriched one. Callers read
    // the exposed error/statusCode refs, since execute() resolves rather than rejecting.
    const sync = async (performanceMomentId: number) => {
        payload.value.performance_moment_id = performanceMomentId;
        return await execute();
    };

    return {
        ...fetch,
        sync,
    };
};
